import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { loadRuntimeConfig } from './lib/config';
import { ConfigContext, ApiContext } from './lib/context';
import { createMiniAppApi } from './lib/api';
import { useSessionStore } from './lib/session-store';
import './styles.css';

async function bootstrap() {
  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error('Root element not found');
  }

  try {
    const config = await loadRuntimeConfig();
    console.log('[Bootstrap] Config loaded:', { apiBaseUrl: config.apiBaseUrl, buildVersion: config.buildVersion });
    
    const api = createMiniAppApi(config, () => {
      const snapshot = useSessionStore.getState();
      return {
        sessionToken: snapshot.sessionToken,
        userId: snapshot.userId,
        telegramUserId: snapshot.telegramUserId,
      };
    });

    const queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          retry: 1,
          refetchOnWindowFocus: false,
          staleTime: 30000, // 30 seconds
        },
      },
    });

    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <ConfigContext.Provider value={config}>
          <ApiContext.Provider value={api}>
            <QueryClientProvider client={queryClient}>
              <App />
            </QueryClientProvider>
          </ApiContext.Provider>
        </ConfigContext.Provider>
      </React.StrictMode>
    );
  } catch (error) {
    console.error('[Bootstrap] Failed to initialize:', error);
    throw error; // Re-throw to be caught by bootstrap().catch()
  }
}

bootstrap().catch(error => {
  console.error('[Bootstrap] Fatal error:', error);
  const rootElement = document.getElementById('root');
  if (rootElement) {
    rootElement.innerHTML = `
      <div style="padding:24px;color:#ff6b6b;font-family:system-ui,-apple-system,sans-serif;max-width:600px;margin:0 auto;">
        <h1 style="margin:0 0 16px 0;font-size:20px;">Ошибка загрузки приложения</h1>
        <p style="margin:0 0 16px 0;color:#666;line-height:1.5;">
          Не удалось инициализировать приложение. Проверьте консоль браузера для подробностей.
        </p>
        <details style="margin-top:16px;">
          <summary style="cursor:pointer;color:#999;font-size:14px;">Технические детали</summary>
          <pre style="margin-top:8px;padding:12px;background:#f5f5f5;border-radius:4px;overflow:auto;font-size:12px;">${error instanceof Error ? error.message : String(error)}</pre>
        </details>
        <button 
          onclick="window.location.reload()" 
          style="margin-top:16px;padding:10px 20px;background:#51cf66;color:#0f1115;border:none;border-radius:8px;font-weight:600;cursor:pointer;"
        >
          Перезагрузить страницу
        </button>
      </div>
    `;
  }
});
